const getOffset = (element: HTMLElement) => {
  if (!element.getClientRects().length) {
    return { top: 0, left: 0 };
  }

  const rect = element.getBoundingClientRect();
  const win = element.ownerDocument.defaultView;
  return {
    top: rect.top + (win?.pageYOffset || 0),
    left: rect.left + (win?.pageXOffset || 0),
  };
};

const isOverlapped = (elementToBeOverlapped?: HTMLElement | null, elementOverlapping?: HTMLElement | null) => {
  if (!elementToBeOverlapped || !elementOverlapping) return false;

  const fixed_position = getOffset(elementOverlapping).top;
  const fixed_height = elementOverlapping.clientHeight;

  const toCross_position = getOffset(elementToBeOverlapped).top;
  const toCross_height = elementToBeOverlapped.clientHeight;

  if (fixed_position + fixed_height < toCross_position) {
    // return true;
    return false;
  } else if (fixed_position > toCross_position + toCross_height) {
    // return true;
    return false;
  } else {
    // return false;
    return true;
  }
};

const isOverlappedByHeaderOrNavBtns = (elementToBeOverlapped?: HTMLElement) => {
  const navbar = document.getElementById('NavbarFixed');
  const brandHeader = document.getElementById('brand-header');
  const navBtns = document.getElementById('navBtns');
  if (isOverlapped(elementToBeOverlapped, navbar) || isOverlapped(elementToBeOverlapped, brandHeader)) {
    window.scrollBy(0, -100);
    return;
  }
  if (isOverlapped(elementToBeOverlapped, navBtns)) {
    window.scrollBy(0, 150);
    return;
  }
};

export { isOverlappedByHeaderOrNavBtns };
